import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import App from './App';
import './index.css';

import { setCulture, setCurrencyCode, loadCldr } from '@syncfusion/ej2-base';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as caGregorian from 'cldr-data/main/he/ca-gregorian.json';
import * as numbers from 'cldr-data/main/he/numbers.json';
import * as timeZoneNames from 'cldr-data/main/he/timeZoneNames.json';
import * as currencies from 'cldr-data/main/he/currencies.json';

// Load Hebrew culture data
loadCldr(numberingSystems, caGregorian, numbers, timeZoneNames, currencies);

// Set culture and currency
setCulture('he');                 // Hebrew culture
setCurrencyCode('ILS');           // ✅ Force Israeli Shekel


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
); 